import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Errors, actions, Control } from 'react-redux-form';
import get from 'lodash/get';

import InputField from '../Forms/Controls/Field';
import {
  validatePassword,
  validatePasswordChars,
} from '../Forms/Validators';
import BaseDetailScreen from '../BaseDetailScreen';
import Button from '../Button';
import { changeCredentialsPath } from '../Forms/Schemas/baseRrf';
import {
  changePassphrase,
  navigate,
} from '../../actions';
import { addNotification } from '../../actions/notifications';

import './styles.css';


const fields = [
  {
    model: '.currentPassphrase',
    RRFComp: Control.text,
    control: {
      type: 'password',
      placeholder: 'Current Password',
      errors: {
        required: val => !val || !val.length,

        // `incorrect` after 401 response for server.
        // Set to false here so when user edit field the error message
        // is removed.
        incorrect: () => false,
      },
    },
    error: {
      messages: {
        required: 'Please enter your current password.',
        incorrect: 'Incorrect password',
      },
    },
  },
  {
    model: '.newPassphrase',
    RRFComp: Control.text,
    control: {
      type: 'password',
      placeholder: 'New Password',
      errors: {
        required: val => !val || !val.length,
        length: val => val && !validatePassword(val),
        chars: val => val && !validatePasswordChars(val),
      },
    },
    error: {
      component: props => <div>{props.children}</div>,
      show: field => !field.pristine,
      messages: {
        required: 'Please enter your new password.',
        length: 'Password must be at least 8 characters.',
        chars: 'Value must contain at least one uppercase letter, one lowercase letter, one number and one special character (!@#$%^&?*).',
      },
    },
  },
  {
    model: '.verifyNewPassphrase',
    RRFComp: Control.text,
    control: {
      type: 'password',
      placeholder: 'Confirm New Password',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please confirm your new password.',
      },
    },
  },
];


class AccountChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
  }

  componentWillUnmount() {
    this.props.reset();
  }

  onSubmit = async () => {
    if (this.state.submitting) {
      return;
    }
    this.setState({ submitting: true });

    const { currentPassphrase, newPassphrase } = this.props.formData;
    try {
      await this.props.changePassphrase(currentPassphrase, newPassphrase);
      await this.props.reset();
      this.props.navigate(`/account/${this.props.accountNumber}`);
      return;
    } catch (err) {
      if (err.res && err.res.status === 401) {
        this.props.setErrors(`${changeCredentialsPath}.currentPassphrase`, {
          incorrect: true,
        });
      } else if (err.res && err.res.status === 400) {
        const resBody = await err.res.json();
        const fieldErrors = Object.keys(resBody.error.validationErrors).reduce((acc, name) => {
          acc[name] = resBody.error.validationErrors[name].msg;
          return acc;
        }, {});
        this.props.setFieldsErrors(changeCredentialsPath, fieldErrors);
      } else {
        this.props.addNotification(err.toString());
      }
    }
    this.setState({ submitting: false });
  };

  render() {
    return (
      <BaseDetailScreen
        backLabel="Manage Account"
        backTo={`/account/${this.props.accountNumber}`}
        pageHeading="Change Password"
      >
        <div styleName="changePassword">
          <Form
            model={changeCredentialsPath}
            onSubmit={this.onSubmit}
            className={this.state.submitting ? 'submitting' : ''}
            validators={{
              '': {
                passwordsMatch: vals => (
                  vals.newPassphrase === '' ||
                  vals.newPassphrase === vals.verifyNewPassphrase
                ),
                matchesCurrentPassword: vals => (
                  vals.currentPassphrase === '' ||
                  vals.currentPassphrase !== vals.newPassphrase
                ),
              },
            }}
          >
            <div styleName="spaceBetweenFormGroups">
              {fields.map(field => (<InputField key={field.model} fieldProps={field} />))}
              <Errors
                styleName="errorText"
                show={form => form.touched || form.submitted}
                model={changeCredentialsPath}
                messages={{
                    passwordsMatch: 'New password must match.',
                    matchesCurrentPassword: 'New password must not match old password.',
                  }}
              />
            </div>
            <div styleName="submitButtonContainer">
              <Button
                disabled={this.state.submitting}
                type="submit"
              >
                {this.state.submitting ? 'Changing Password...' : 'Change Password'}
              </Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
  }
}


const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
  formData: get(state, changeCredentialsPath),
});


const mapDispatchToProps = {
  changePassphrase,
  setValidity: actions.setValidity,
  setErrors: actions.setErrors,
  setFieldsErrors: actions.setFieldsErrors,
  reset: () => actions.reset(changeCredentialsPath),
  addNotification,
  navigate,
};


export default connect(mapStateToProps, mapDispatchToProps)(AccountChangePassword);



// WEBPACK FOOTER //
// ./src/components/AccountChangePassword/index.js